import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'camelCase',
})
export class CamelCasePipe implements PipeTransform {
    transform(value?: string): string {
        if (typeof value !== 'string') {
            return '';
        }

        const words = value.replace(/\s+/g, ' ').split(' ').filter(Boolean);

        return words.length > 1
            ? words
                  .slice(1)
                  .reduce(
                      (prev, curr) =>
                          prev +
                          (curr[0].toUpperCase() || '') +
                          (curr?.slice(1)?.toLowerCase() + ''),
                      this.firstWord(words[0]),
                  )
            : words[0]?.toLowerCase() || '';
    }

    private firstWord(word: string) {
        return (
            (word[0].toLowerCase() || '') +
            (word?.slice(1)?.toLowerCase() || '')
        );
    }
}
